var _defs, _rect, _rect2, _rect3, _g, _use, _path, _path2, _use2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-120 -80 240 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "spearshape",
    d: "M -1,55.4256258422040733928782829281879157421699 h 2 V -38 C 3,-40 3,-43 3,-46 C 3,-48 3,-56 0,-64.6632301492380856250246634162192350325315 C -3,-56 -3,-48 -3,-46 C -3,-43 -3,-40 -1,-38 z",
    strokeMiterlimit: 10,
    transform: "rotate(30)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -120,
    y: -80,
    width: 240,
    height: 160,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -120,
    y: -80,
    width: 240,
    height: 48
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -120,
    y: 32,
    width: 240,
    height: 48,
    fill: "#060"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "spear"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spearshape",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spearshape",
    fill: "#fff"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spear",
    transform: "scale(-1,1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b00",
    d: "M -120,-24 V 24 H -19 c 3,8 13,24 19,24 s 16,-16 19,-24 H 120 V -24 H 19 c -3,-8 -13,-24 -19,-24 s -16,16 -19,24 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "deco_r",
    d: "M 19,24 c 3,-8 5,-16 5,-24 s -2,-16 -5,-24 c -3,8 -5,16 -5,24 s 2,16 5,24"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#deco_r",
    transform: "scale(-1,1)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 4,
    ry: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "deco_br",
    d: "M 1,5.85 c 0,0 4,8 4,21 s -4,21 -4,21 z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#deco_br",
    transform: "scale(-1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#deco_br",
    transform: "scale(-1,1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#deco_br",
    transform: "scale(1,-1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKe);
export default __webpack_public_path__ + "static/media/ke.7a93d3a68644b436c0b10f9d4f418875.svg";
export { ForwardRef as ReactComponent };